module.exports = __webpack_public_path__ + "static/media/sn.5687de18.svg";